import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/Header/BackBlue.png'
import _imports_1 from '../../assets/img/Header/BackGreen.png'
import _imports_2 from '../../assets/img/Header/BackPhotos.png'


const _withScopeId = n => (_pushScopeId("data-v-257b08da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-half" }
const _hoisted_2 = { class: "header-text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Next generation digital banking", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Take your financial life online. Your Easybank account will be a one-stop-shop for spending, saving, budgeting, investing, and much more. ", -1))
const _hoisted_5 = { class: "header-button" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "header-blue",
    src: _imports_0,
    alt: "Blue background image"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "header-green",
    src: _imports_1,
    alt: "Green background image"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "header-phone",
    src: _imports_2,
    alt: "Phones background image"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonRequest = _resolveComponent("ButtonRequest")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(_ctx.headerClass)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_ButtonRequest, { text: "Request Invite" })
        ])
      ])
    ]),
    _hoisted_6
  ], 2))
}